import { Component } from 'react';
import {
    get,
    head,
    isEqual,
    isEmpty
} from 'lodash';

import DataSourceValueLoader from 'common/containers/DataSourceValueLoader/DataSourceValueLoader';
import AutocompleteDataSource from 'common/components/AutocompleteDataSource/AutocompleteDataSource';
import DataTypeEditor from 'common/components/DataTypeEditor/DataTypeEditor';
import styles from '../ValueSets.scss';

class DataSourceSingleValue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            errorMessage: null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.validationErrors, this.props.validationErrors)) {
            this.setState({
                errorMessage: get(head(this.props.validationErrors), 'message')
            });
        }
        if(!isEqual(prevProps.value, this.props.value)){
            this.setState({
                errorMessage : `${this.props.value} is not a value from the list` 
            });
        }
    }

    isSelectedValueValid() {
        const { hasError } = this.state;
        return !hasError;
    }

    onValidStateChange(autocompleteSource, { hasError, editorValue }) {
        this.setState({
            hasError,
            errorMessage: `${editorValue} is not a value from the list`
        });
    }

    shouldShowError() {
        const { hasError } = this.state;
        const {
            value,
            validationErrors
        } = this.props;

        return hasError || (!value && !isEmpty(validationErrors));
    }

    render() {
        const {
            value,
            changeHandler,
            dataType,
            dataSourceId,
        } = this.props;

        const { errorMessage } = this.state;
        const hasError = this.shouldShowError();

        return (
            <div className={styles.container} data-cy="dataSourceSingleValue">
                { hasError &&
                    <span className={styles.errorMessage}>{errorMessage}</span>
                }
                <DataSourceValueLoader dataSourceId={dataSourceId}>
                    <ValuePicker
                        value={value}
                        onChange={changeHandler}
                        dataType={dataType}
                        hasError={hasError}
                        onValidStateChange={this.onValidStateChange.bind(this)} />
                </DataSourceValueLoader>
            </div>
        );
    }
}

function ValuePicker({
    dataSourceItems,
    value,
    onChange,
    dataType,
    onValidStateChange,
    hasError
}) {
    return (
        <AutocompleteDataSource
            values={dataSourceItems}
            value={value}
            onChange={onChange}
            dataType={dataType}
            validate={true}
            onValidStateChange={onValidStateChange}>
            <DataTypeEditor
                className={`${styles.dataTypeEditor} ${hasError && styles.dataTypeEditorError}`} />
        </AutocompleteDataSource>
    );
}

export default DataSourceSingleValue;
